import { heatColor } from "./heatColor";

// Rekent uit waar de halve meter en zijn schaalstreepjes komen te staan.
// Puur rekenwerk: geen React, makkelijk los te controleren.

const tickCount = 60; // 61 streepjes, dus om de drie graden één
const tickMajorEvery = 15; // grote streep om de 25%

const tickGap = 10; // lucht tussen de band en de streepjes
const tickMinor = 9;
const tickMajor = 16;
const padX = 16;
const padTop = 14;
const padBottom = 34; // ruimte voor de 0 en 100 onder de uiteinden

export function gaugeGeometry(size, stroke, progress) {
  const cx = size / 2;
  const radius = cx - padX - tickMajor - tickGap - stroke / 2;
  const cy = padTop + tickMajor + tickGap + radius + stroke / 2;

  const length = Math.PI * radius;

  return {
    cx,
    cy,
    radius,
    height: cy + stroke / 2 + padBottom,
    path: `M ${cx - radius} ${cy} A ${radius} ${radius} 0 0 1 ${cx + radius} ${cy}`,
    length,
    // De boog schuift open door het streepjespatroon te verschuiven.
    dashOffset: length * (1 - progress),
    ticks: buildTicks({ cx, cy, radius, stroke, progress }),
  };
}

function buildTicks({ cx, cy, radius, stroke, progress }) {
  return Array.from({ length: tickCount + 1 }, (_, i) => {
    const fraction = i / tickCount;
    const angle = Math.PI * (1 - fraction);
    const major = i % tickMajorEvery === 0;

    const inner = radius + stroke / 2 + tickGap;
    const outer = inner + (major ? tickMajor : tickMinor);
    const passed = fraction <= progress + 0.0001;

    return {
      x1: cx + inner * Math.cos(angle),
      y1: cy - inner * Math.sin(angle),
      x2: cx + outer * Math.cos(angle),
      y2: cy - outer * Math.sin(angle),
      major,
      // Streepjes verderop lichten iets later op, zodat het licht de kop
      // van de boog achterna loopt in plaats van alles tegelijk aan te gaan.
      delay: fraction * 0.95,
      color: passed
        ? heatColor(Math.max(12, fraction * 100))
        : `rgba(255, 255, 255, ${major ? 0.32 : 0.15})`,
      width: major ? 3.4 : 2,
    };
  });
}
